import { render, staticRenderFns } from "./NotificationsCard.vue?vue&type=template&id=f52f3584&scoped=true&"
import script from "@/components/notifications-card/NotificationsCard.ts?vue&type=script&lang=ts&"
export * from "@/components/notifications-card/NotificationsCard.ts?vue&type=script&lang=ts&"
import style0 from "@/components/notifications-card/notifications-card.scss?vue&type=style&index=0&id=f52f3584&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52f3584",
  null
  
)

export default component.exports